<template>
  <div>
    <el-row :gutter="10">
      <el-col :lg="{ span: 24 }" :xl="{ span: 24 }">
        <el-descriptions
          class="border-detail-main-form"
          border
          size="small"
          :column="4"
        >
          <el-descriptions-item
            :label="'SkuNo'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '150px' }"
          >
            {{ formData.hxSkuNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '100px' }"
            :label="$l('INDEX.Status') || '状态'"
          >
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.hxSkuStatus === 'Y'
                  ? 'success'
                  : formData.hxSkuStatus === 'D'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_hxSkuStatus || '企划' }}
            </b-badge>
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '100px' }"
            :label="$l('INDEX.VC') || 'VC产品'"
          >
            <el-tag
              v-if="formData.isVc"
              size="mini"
              effect="dark"
              :type="formData.isVc == 'Y' ? 'warning' : ''"
            >
              {{ formData.v_isVc }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '150px' }"
            :label="$l('INDEX.modify_date') || '更改时间'"
          >
            {{ formData.modifyDate || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>

      <el-col :span="24">
        <el-descriptions
          class="border-detail-main-form"
          border
          size="small"
          :column="2"
        >
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '350px' }"
            :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
          >
            {{ formData.goodsName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '350px' }"
            :label="$l('INDEX.form_label_goodsNameEn') || '英文名称'"
          >
            {{ formData.goodsNameEn || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>

      <el-col :lg="{ span: 24 }" :xl="{ span: 24 }">
        <el-descriptions
          class="border-detail-main-form"
          border
          size="small"
          :column="3"
        >
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '150px' }"
            :label="$l('INDEX.form_label_brand') || '品牌'"
          >
            {{ formData.brandName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '200px' }"
            :label="$l('INDEX.form_label_succession') || '系列'"
          >
            {{ formData.collectionName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '250px' }"
            :label="$l('INDEX.table_label_category') || '分类'"
          >
            {{ formData.categoryFullName || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_pattern') || '花型'
            "
            prop="goodsPattern"
          >
            <el-input
              v-model="formData.goodsPattern"
              :disabled="formalDisabled"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorCn') || '中文颜色'"
            prop="goodsColor"
          >
            <el-input
              v-model="formData.goodsColor"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorEn') || '英文颜色'"
            prop="goodsColorEn"
          >
            <el-input
              v-model="formData.goodsColorEn"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_sku_pack_size') || '售卖方式'"
            prop="skuPackSize"
          >
            <dict-select
              v-model="formData.skuPackSize"
              url="/master/common/dict/biz"
              :body="{ dictType: 'skuPackSize' }"
              :selectedLabel.sync="formData.skuPackSizeName"
              clearable
              filterable
              :disabled="formalDisabled"
              size="mini"
              style="width:100%"
              @change="packChange"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.eanCode') || 'EAN条码'"
            prop="eanCode"
          >
            <el-input
              v-model="formData.eanCode"
              clearable
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_eanCode') || '请输入EAN条码'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :span="18">
          <el-form-item
            :label="$l('INDEX.form_label_goodsSize') || '产品尺寸'"
            prop="goodsSize"
          >
            <product-size
              size="mini"
              :disabled="formalDisabled"
              :formData="formData"
              :isSingle="isSingle"
              @confirm="(e) => changeGoodsSize(e)"
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_design') || '企划人员'"
            prop="designCode"
          >
            <dict-select
              v-model="formData.designCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.designName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <el-input v-model="formData.buyerName" clearable readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input v-model="formData.ncNo" clearable readonly> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_Factory_Default') || '成品工厂(默认)'"
            prop="scmCode"
          >
            <el-input v-model="formData.scmName" clearable readonly />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ftyPrice') || '工厂单价(rmb)'"
            prop="ftyPrice"
          >
            <el-input v-model="formData.ftyPrice" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="'MOQ'">
            <el-input v-model="formData.ftyMoq" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="'生产周期（天）'">
            <el-input v-model="formData.ftyLeadTime" clearable readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_materialInfo') || '材料信息'"
            prop="materialInfo"
          >
            <el-input
              v-model="formData.materialInfo"
              clearable
              type="textarea"
              :rows="4"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_inCtnQty') || '装箱入数'"
            prop="inCtnQty"
          >
            <el-input-number
              v-model="formData.inCtnQty"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="0"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnLength') || '纸箱长(cm)'"
                prop="ctnLength"
              >
                <el-input-number
                  v-model="formData.ctnLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnWidth') || '纸箱宽(cm)'"
                prop="ctnWidth"
              >
                <el-input-number
                  v-model="formData.ctnWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnHeight') || '纸箱高(cm)'"
                prop="ctnHeight"
              >
                <el-input-number
                  v-model="formData.ctnHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_ctnGrossWeight') || '箱毛重(kg)'"
          >
            <el-input-number
              v-model="ctnGrossWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnCbm') || '纸箱体积(m³)'"
          >
            <el-input v-model="ctnCbm" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="11" :offset="3">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnLength_read') || '纸箱长(英寸)'"
              >
                <el-input
                  v-model="ctnLengthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnWidth_read') || '纸箱宽(英寸)'"
              >
                <el-input
                  v-model="ctnWidthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnHeight_read') || '纸箱高(英寸)'"
              >
                <el-input
                  v-model="ctnHeightRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_boxNetWeight_read') || '箱净重(磅)'"
          >
            <el-input
              v-model="ctnNetWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_ctnGrossWeight_read') || '箱毛重(磅)'"
          >
            <el-input
              v-model="ctnGrossWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnCbm_read') || '纸箱体积(英尺³)'"
          >
            <el-input v-model="ctnCbmRead" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import {
  multiply,
  multiplyRound,
  divideRound,
  add,
} from '@/libs/util.number.js'
import { request } from '@/api/service'
import ProductSize from '../product-size'

export default {
  mixins: [EditLoading],
  components: { ProductSize },
  props: {
    hxSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    hxSkuStatus: { type: String, default: '' },
    hxSpuCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
    isCopy: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        colorCode: '',
        goodsColorEn: '',
        goodsColor: '',
        goodsName: '',
        goodsNameEn: '',
        designCode: '',
        designName: '',
        isVc: '',
      },
      formalDisabled: false,
      masterCategoryParams: { parentCode: 'ABSHome' },
      categoryTree: [],
      colorOptions: [],
      ctnGrossWeightKgRead: 0,
    }
  },
  computed: {
    detailCategoryParams() {
      return { parentCode: this.formData.masterCategoryCode || 'x' }
    },
    unitCbm() {
      const { unitLength, unitWidth, unitHeight } = this.formData
      return divideRound(
        multiply(multiply(unitLength, unitWidth), unitHeight),
        1000000,
        8
      )
    },
    ctnCbm() {
      const { ctnLength, ctnWidth, ctnHeight } = this.formData
      return divideRound(
        multiply(multiply(ctnLength, ctnWidth), ctnHeight),
        1000000,
        8
      )
    },
    isSingle() {
      return 'single' == this.formData.skuPackSize
    },
    unitLengthRead() {
      return divideRound(this.formData.unitLength, 2.54, 7)
    },
    unitWidthRead() {
      return divideRound(this.formData.unitWidth, 2.54, 7)
    },
    unitHeightRead() {
      return divideRound(this.formData.unitHeight, 2.54, 7)
    },
    goodsWeightRead() {
      return multiplyRound(this.formData.goodsWeight, 2.20462262185, 7)
    },
    unitWeightRead() {
      return multiplyRound(this.formData.unitWeight, 2.20462262185, 7)
    },
    unitCbmRead() {
      return multiplyRound(this.unitCbm, 35.3147248, 7)
    },
    ctnLengthRead() {
      return divideRound(this.formData.ctnLength, 2.54, 7)
    },
    ctnWidthRead() {
      return divideRound(this.formData.ctnWidth, 2.54, 7)
    },
    ctnHeightRead() {
      return divideRound(this.formData.ctnHeight, 2.54, 7)
    },
    ctnNetWeightRead() {
      return multiplyRound(this.ctnNetWeightKgRead, 2.20462262185, 7)
    },
    ctnGrossWeightRead() {
      return multiplyRound(this.ctnGrossWeightKgRead, 2.20462262185, 7)
    },
    ctnNetWeightKgRead() {
      return multiplyRound(this.formData.unitWeight, this.formData.inCtnQty, 3)
    },
    ctnCbmRead() {
      return multiplyRound(this.ctnCbm, 35.3147248, 7)
    },
    required() {
      return !this.hxSpuCode
    },
    rules() {
      return {
        goodsName: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameCn') || '请输入中文名称',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称',
            trigger: 'blur',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('INDEX.form_placeholder_brand') || '请选择品牌',
            trigger: 'blur',
          },
        ],
        skuPackSize: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_sellTypes') || '请选择售卖方式',
            trigger: 'blur',
          },
        ],
        detailCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_masterCategory') || '请选择品类',
            trigger: ' change',
          },
        ],
        goodsColor: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsColorCn') ||
              '请输入中文颜色',
            trigger: 'blur',
          },
        ],
        goodsColorEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsColorEn') ||
              '请输入英文颜色',
            trigger: 'blur',
          },
        ],
        goodsSize: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsSize') || '请输入产品尺寸',
            trigger: 'blur',
          },
        ],
        goodsPattern: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsPattern') ||
              '请输入花型',
            trigger: 'blur',
          },
        ],
        colorCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isVc: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        eanCode: [
          {
            required: this.formData.isVc == 'Y',
            message: this.$l('INDEX.tips_input_eanCode') || '请输入EAN条码',
            trigger: 'change',
          },
        ],
        designCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_design') || '请选择企划人员',
            trigger: 'blur',
          },
        ],
        materialInfo: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_materialInfo') ||
              '请输入材料信息',
            trigger: 'blur',
          },
        ],
        goodsProperties: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_goodsProperties') ||
              '请输入产品属性',
            trigger: 'blur',
          },
        ],
        unitLength: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitLength') ||
              '请输入单品包装长',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitWidth') || '请输入单品包装宽',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitHeight') ||
              '请输入单品包装高',
            trigger: 'blur',
          },
        ],
        goodsWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_goodsWeight') || '请输入单品重量',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitWeight') ||
              '请输入单品包装重量',
            trigger: 'blur',
          },
        ],
        inCtnQty: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_inCtnQty') || '请输入装箱入数',
            trigger: 'blur',
          },
        ],
        ctnLength: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnLength') || '请输入纸箱长',
            trigger: 'blur',
          },
        ],
        ctnWidth: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnWidth') || '请输入纸箱宽',
            trigger: 'blur',
          },
        ],
        ctnHeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnHeight') || '请输入纸箱高',
            trigger: 'blur',
          },
        ],
        ctnNetWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnNetWeight') || '请输入箱净重',
            trigger: 'blur',
          },
        ],
        ctnGrossWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnGrossWeight') ||
              '请输入箱毛重',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
    this.getSpuData()
    this.getTreeData()
    this.getColor()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.hxSkuCode) return
      let res = undefined
      if (this.isCopy) {
        res = await this.$api
          .ecomHxSkuCopyApi({ hxSkuCode: this.hxSkuCode })
          .catch(() => null)
      } else {
        res = await this.$api
          .ecomHxSkuDetailApi({ hxSkuCode: this.hxSkuCode })
          .catch(() => null)
      }
      if (!res) return
      const data = res.body || {}
      this.formData = data
      this.ctnGrossWeightKgRead = this.formData.ctnGrossWeight
      this.formalDisabled = this.formData.hxSkuStatus == 'Y'
      this.$emit('update:hxSkuStatus', data.hxSkuStatus || '')
    },
    getSpuData() {
      if (this.hxSkuCode) return
      if (!this.hxSpuCode) return
      this.$api
        .ecomHxSpuDetailApi({ hxSpuCode: this.hxSpuCode })
        .then((res) => {
          const data = res.body
          this.formData.spuGoodsName = data.goodsName
          this.formData.spuGoodsNameEn = data.goodsNameEn
          this.formData.goodsName = data.goodsName
          this.formData.goodsNameEn = data.goodsNameEn
          this.formData.brandCode = data.brandCode
          this.formData.brandName = data.brandName
          this.formData.collectionNo = data.collectionNo
          this.formData.collectionName = data.collectionName
          this.formData.masterCategoryName = data.masterCategoryName
          this.formData.masterCategoryCode = data.masterCategoryCode
          this.formData.detailCategoryCode = data.categoryCode
          this.formData.detailCategoryName = data.categoryName
          this.formData.categoryFullName = data.categoryFullName
          this.formData.designCode = data.designCode
          this.formData.designName = data.designName
          this.formData.isVc = data.isVc
          this.formData.v_isVc = data.isVc == 'Y' ? 'VC' : '否'
        })
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
      if (nodes?.length && nodes[0] && nodes[0].path?.length) {
        this.formData.displayCategoryCode = nodes[0].path.join(',')
        this.formData.masterCategoryCode = nodes[0].path[0]
      } else {
        this.formData.displayCategoryCode = null
        this.formData.masterCategoryCode = null
      }
    },
    getColor() {
      request({
        url: '/ecom/amz/sku/dict/color',
        method: 'post',
        data: { isCustomer: 'Y' },
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    async reloadSku() {
      if (!this.hxSkuCode) return
      const res = await this.$api
        .ecomHxSkuDetailApi({ hxSkuCode: this.hxSkuCode })
        .catch(() => null)
      if (!res) return
      const data = res.body || {}
      const {
        scmCode,
        scmName,
        ncNo,
        ftyPrice,
        ftyMoq,
        ftyLeadTime,
        buyerCode,
        buyerName,
      } = data
      this.formData.scmCode = scmCode
      this.formData.scmName = scmName
      this.formData.buyerCode = buyerCode
      this.formData.buyerName = buyerName
      this.formData.ncNo = ncNo
      this.formData.ftyPrice = ftyPrice
      this.formData.ftyMoq = ftyMoq
      this.formData.ftyLeadTime = ftyLeadTime
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.saveApi()
      this.loadingClose()
      if (!res) return
      const { status, body } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.hxSkuCode && !this.hxSpuCode) {
        // await this.closeCurPage()
        this.$router.replace({
          name: 'ecom-base-awsGoods-detail',
          params: { code: body, pageType: 'edit' },
          query: { hxSkuNo: this.formData.hxSkuNo },
        })
        return
      }
      this.$emit('update:hxSkuCode', body || '')
      this.$emit('update:isCopy', false)
      this.$emit('onIsCopy', false)
      setTimeout(() => {
        this.getData()
      }, 0)
    },
    saveApi() {
      const params = {
        ...this.formData,
        unitCbm: this.unitCbm,
        ctnCbm: this.ctnCbm,
        ctnNetWeight: this.ctnNetWeightKgRead,
        ctnGrossWeight: this.ctnGrossWeightKgRead,
        hxSpuCode: this.hxSpuCode || this.formData.hxSpuCode,
      }
      let goodsName = params.spuGoodsName
      let goodsNameEn = params.spuGoodsNameEn
      if (!this.formalDisabled && !!goodsName && !!goodsNameEn) {
        if ('single' == params.skuPackSize) {
          goodsName = goodsName + params.goodsColor + params.goodsSize
          goodsNameEn =
            goodsNameEn + ' ' + params.goodsColorEn + ' ' + params.goodsSize
        } else {
          goodsName = goodsName + params.skuPackSizeName + params.goodsColor
          goodsNameEn =
            goodsNameEn + ' ' + params.skuPackSize + ' ' + params.goodsColorEn
        }
        params.goodsName = goodsName
        params.goodsNameEn = goodsNameEn
      }
      if ((this.hxSpuCode && !this.hxSkuCode) || this.isCopy) {
        params.oldHxSkuCode = this.hxSkuCode
        return this.$api.ecomHxSpuAddSkuApi(params).catch(() => null)
      } else {
        return this.$api.ecomHxSkuSaveApi(params).catch(() => null)
      }
    },
    changeCtnGrossWeight() {
      this.ctnGrossWeightKgRead = add(this.ctnNetWeightKgRead, 1)
    },
    changeGoodsSize(val) {
      this.$refs.form.clearValidate('goodsSize')
      const { goodsSize, hxSkuSpecList } = val
      this.formData = {
        ...this.formData,
        goodsSize,
        hxSkuSpecList,
      }
    },
    packChange() {
      this.formData.goodsSize = ''
      this.formData.hxSkuSpecList = []
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.colorCard {
  float: right;
  margin: 3px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  color: #ffffff;
}

.side-frame-success {
  padding: 2px 10px;
  border-left: 3px solid $color-success;
  margin: 0;
}
.border-detail-main-form {
  margin-top: -1px;
}

.brand-select {
  height: auto !important;
  line-height: 20px !important;
  margin: 6px 0;
  .brand-select-item {
    display: block;
  }
}
</style>
